import { getRaindropEnvironment } from "./environment";

export const MAX_NUMBER_OF_ORGANISATIONS_SAPPHIRE = 9;
// e.g. 9  - The maximum number of organisations a user can have in their account

export const MAX_NUMBER_OF_ORGANISATIONS_EMERALD = 3;
// e.g. 4  - The maximum number of organisations a user can have in their account on the Emerald Version

export const RAINDROP_ENVIRONMENT = getRaindropEnvironment();
// e.g. PRODUCTION  - The current environment of the application

export const URL_BACKEND = {
  LOCAL: "http://localhost:2000",
  STAGING: "https://api-staging.theraindropcompany.com",
  PRODUCTION: "https://api.theraindropcompany.com",
}[RAINDROP_ENVIRONMENT];
// e.g. https://api.theraindropcompany.com  - The URL of the Backend API

export const URL_RAINDROP = {
  LOCAL: "http://localhost:2001/raindrop",
  STAGING: "https://app-staging.theraindropcompany.com",
  PRODUCTION: "https://app.theraindropcompany.com",
}[RAINDROP_ENVIRONMENT];
// e.g. https://app.theraindropcompany.com  - The URL of the Raindrop app

export const URL_STRATUS = {
  LOCAL: "http://localhost:2001",
  STAGING: "https://www-staging.theraindropcompany.com",
  PRODUCTION: "https://www.theraindropcompany.com",
}[RAINDROP_ENVIRONMENT];
// e.g. https://www.theraindropcompany.com  - The URL of the Raindrop website (codename Stratus)

export const URL_CIRRUS = {
  LOCAL: "http://localhost:2001",
  STAGING: "https://cirrus-staging.theraindropcompany.com",
  PRODUCTION: "https://cirrus.theraindropcompany.com",
}[RAINDROP_ENVIRONMENT];

export const STRIPE_PUBLISHABLE_KEY = {
  LOCAL:
    "pk_test_51OdebPFI9IG5zcYV0ptkMLhEeDt2FmdISoxRbPS0yxL6GQO4m7UPHPdgZavq60To4bhYgTPisoyDa392SnVeCdJs0069gVyXhM",
  STAGING:
    "pk_test_51OdebPFI9IG5zcYV0ptkMLhEeDt2FmdISoxRbPS0yxL6GQO4m7UPHPdgZavq60To4bhYgTPisoyDa392SnVeCdJs0069gVyXhM",
  PRODUCTION:
    "pk_live_51OdebPFI9IG5zcYVuQsUyQEBWiC3eNpQbbm9yNK80l3Oo7YL5UG7pT1PuprpSEepFLW2WbiEgQrBZgfevtbshqWz00qmwXjkPN",
}[RAINDROP_ENVIRONMENT];
// e.g. pk_live_51O...  - The Stripe Publishable Key, this is safe to be committed to version control.  NEVER COMMIT THE SECRET KEY.

export const VERSION = "0.6.1";
// e.g. 0.4.0  - The current version of the application, update this arbitrarily

// START - Consider for deletion
export const EXAMPLE_ACCOUNT_USER_URL =
  "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/demo-user-profile-picture__BBBC2081-7E50-4BEE-93C1-7C514E43866E.jpeg";

export const EXAMPLE_ACCOUNT_USER_ACTIVITY_URL =
  "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/demo-waterfall-activity-6C04F963-DA08-4A44-861C-79DF892BFFE0.jpeg";

export const EXAMPLE_ORGANISATION_ALPHA_URL =
  "https://production-raindrop-s3-public.s3.eu-west-2.amazonaws.com/organisation_logo__mind.png";

export const EXAMPLE_ORGANISATION_ALPHA_ID =
  "organisation_EEAA5B09-5126-4C37-A7DF-2506B237DD93";

export const EXAMPLE_ORGANISATION_ALPHA_NAME = "Mind";

export const EXAMPLE_ORGANISATION_ALPHA_ACTIVITY_TEXT =
  "Our scientists have discovered a new type of cell which can repair heart tissue";

export const EXAMPLE_ORGANISATION_ALPHA_AD_URL =
  "https://production-raindrop-s3-public.s3.eu-west-2.amazonaws.com/2024-09-23__raindrop-research-trust-ad.001.jpeg";

export const EXAMPLE_ORGANISATION_BETA_NAME = "Greenpeace";

export const EXAMPLE_ORGANISATION_BETA_URL =
  "https://production-raindrop-s3-public.s3.eu-west-2.amazonaws.com/organisation_logo__greenpeace.jpg";

export const EXAMPLE_ORGANISATION_BETA_ACTIVITY_TEXT =
  "You've helped us bring fresh water to 312 people this month.";
// END - Consider for deletion

export const ORGANISATION_TAGS = [
  "ORGANISATION_TAG__PEACE",
  "ORGANISATION_TAG__CHILDREN",
  "ORGANISATION_TAG__ENVIRONMENT",
  "ORGANISATION_TAG__MENTAL_HEALTH",
  "ORGANISATION_TAG__WOMEN",
  "ORGANISATION_TAG__SOCIAL_JUSTICE",
  "ORGANISATION_TAG__FOOD_AND_SHELTER",
  "ORGANISATION_TAG__MEDICAL_RESEARCH",
  "ORGANISATION_TAG__ANIMALS",
];

export const STRIPE_CLIENT_SECRET_FAKE = "seti_fake3k4l5m6n7o8p_secret";
// e.g. seti_fake3k4l5m6n7o8p_secret -- Fake Stripe Client Secret

export const RAINDROP_SESSION_TOKEN_KEY = "raindrop_session_token";
// e.g. raindrop_session_token  - The key for the session token in local storage
